/* Foz Collectables — free-shipping progress bar ($200 threshold) */
(function () {
  var THRESHOLD = 20000; // $200.00 AUD, in cents

  function injectCSS() {
    if (document.getElementById('foz-fsb-css')) return;
    var s = document.createElement('style');
    s.id = 'foz-fsb-css';
    s.textContent = [
      '.foz-fsb-wrap{padding:14px 20px 6px;}',
      '.foz-fsb__msg{margin:0 0 8px;text-align:center;font-size:1.3rem;line-height:1.35;color:rgb(var(--color-foreground));}',
      '.foz-fsb__track{height:8px;border-radius:999px;background:rgba(var(--color-foreground),0.12);overflow:hidden;}',
      '.foz-fsb__fill{height:100%;border-radius:999px;background:rgb(var(--color-foreground));transition:width .35s ease;}',
      '.foz-fsb.is-reached .foz-fsb__fill{background:#2ecc71;}'
    ].join('');
    document.head.appendChild(s);
  }

  function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

  function html(total) {
    var remaining = THRESHOLD - total;
    var reached = remaining <= 0;
    var pct = reached ? 100 : Math.max(3, Math.min(100, Math.round(total / THRESHOLD * 100)));
    var msg = reached
      ? '🎉 You’ve unlocked <strong>FREE shipping!</strong>'
      : 'You’re <strong>' + fmt(remaining) + '</strong> away from <strong>FREE shipping</strong>';
    return '<div class="foz-fsb-wrap"><div class="foz-fsb' + (reached ? ' is-reached' : '') + '">'
      + '<p class="foz-fsb__msg">' + msg + '</p>'
      + '<div class="foz-fsb__track"><div class="foz-fsb__fill" style="width:' + pct + '%;"></div></div>'
      + '</div></div>';
  }

  var observers = [];
  function pauseAll() { observers.forEach(function (o) { o.disconnect(); }); }
  function resumeAll() { observers.forEach(function (o) { o.observe(o.__el, { childList: true, subtree: true }); }); }

  function place(container, total) {
    var ex = container.querySelector('.foz-fsb-wrap');
    if (ex) ex.remove();
    container.insertAdjacentHTML('afterbegin', html(total));
  }

  function render(total) {
    injectCSS();
    pauseAll();
    var drawer = document.querySelector('#CartDrawer .cart-drawer__form');
    var page = document.querySelector('#main-cart-items .js-contents') || document.querySelector('#main-cart-items');
    if (total > 0) {
      if (drawer) place(drawer, total);
      if (page) place(page, total);
    } else {
      document.querySelectorAll('.foz-fsb-wrap').forEach(function (n) { n.remove(); });
    }
    resumeAll();
  }

  function refresh() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price); })
      .catch(function () {});
  }

  function observe(el) {
    if (!el || !window.MutationObserver) return;
    var timer;
    var o = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(refresh, 150); });
    o.__el = el;
    o.observe(el, { childList: true, subtree: true });
    observers.push(o);
  }

  function boot() {
    observe(document.querySelector('#CartDrawer'));
    observe(document.querySelector('#main-cart-items'));
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
